import { IAdvertiser } from "advertiser/model"
import { getAdvertiserFromIdOrName } from "advertiser/tools/common"
import { getStore } from "app/store/store"
import { getUserId } from "user/tools/common"
import { orderEventModule } from "./event"
import {
  ICreateOrUpdateOrderParams,
  IOrder,
  IOrderEventOnSaveParams,
  IOrderFormData,
  IOrderService,
  ISaveOrderResult,
  ORDER_EVENTS
} from "./model"
import { orderRPO } from "./repository"
import { orderActionCreator } from "./store/actions"
import { validateOrderFormData } from "./tools/form"

export const orderSVC: IOrderService = {
  getAllOrders(): Promise<IOrder[]> {
    return new Promise<IOrder[]>((resolve, reject) => {
      orderRPO
        .getAllOrders()
        .then(orders => resolve(orders))
        .catch(error => {
          console.error(error)
          reject("Unable to get all orders")
        })
    })
  },
  createOrder(data: ICreateOrUpdateOrderParams, isDspDeal: boolean): Promise<ISaveOrderResult> {
    return new Promise<ISaveOrderResult>(async (resolve, reject) => {
      const errors = validateOrderFormData(data, isDspDeal)
      const attributes = Object.keys(errors) as Array<keyof IOrderFormData>
      if (attributes.length > 0) {
        return reject(attributes.map(a => errors[a]).join(" ; "))
      }
      const {
        name,
        notes,
        budget,
        budget_currency_id,
        start_date,
        max_impressions,
        unlimitedImpressions,
        end_date,
        advertiserNameOrId
      } = data
      let advertiser: IAdvertiser | string | undefined = undefined
      if (!isDspDeal) {
        advertiser = await getAdvertiserFromIdOrName(advertiserNameOrId)
        if (typeof advertiser === "string") {
          // error advertiser not found
          return reject(advertiser)
        }
      }
      orderRPO
        .createOrder({
          name,
          notes,
          budget,
          budget_currency_id,
          start_date: start_date ? start_date.toISOString() : start_date,
          end_date: end_date ? end_date.toISOString() : end_date,
          max_impressions: unlimitedImpressions ? null : max_impressions,
          advertiser_id: typeof advertiser === "object" ? advertiser.id : undefined,
          representative_id: 0,
          user_id: getUserId()
        })
        .then(order => {
          getStore().dispatch(orderActionCreator.add(order))
          orderEventModule.notify(ORDER_EVENTS.ON_SAVE, { order, isCreation: true } as IOrderEventOnSaveParams)
          resolve({
            order,
            advertiser: advertiser as IAdvertiser
          })
        })
        .catch(error => {
          console.error(error)
          reject("Unable to create new order")
        })
    })
  },
  updateOrder(orderId: number, data: ICreateOrUpdateOrderParams, isDspDeal: boolean): Promise<ISaveOrderResult> {
    return new Promise<ISaveOrderResult>(async (resolve, reject) => {
      const errors = validateOrderFormData(data, isDspDeal)
      const attributes = Object.keys(errors) as Array<keyof IOrderFormData>
      if (attributes.length > 0) {
        return reject(attributes.map(a => errors[a]).join(" ; "))
      }
      const {
        name,
        notes,
        budget,
        budget_currency_id,
        start_date,
        max_impressions,
        unlimitedImpressions,
        end_date,
        advertiserNameOrId
      } = data
      let advertiser: IAdvertiser | undefined | string = undefined
      if (!isDspDeal) {
        advertiser = await getAdvertiserFromIdOrName(advertiserNameOrId)
        if (typeof advertiser === "string") {
          // error advertiser not found
          return reject(advertiser)
        }
      }
      orderRPO
        .updateOrder({
          id: orderId,
          name,
          notes,
          budget,
          budget_currency_id,
          start_date: start_date ? start_date.toISOString() : start_date,
          end_date: end_date ? end_date.toISOString() : end_date,
          max_impressions: unlimitedImpressions ? null : max_impressions,
          advertiser_id: typeof advertiser === "object" ? advertiser.id : undefined
        })
        .then(order => {
          getStore().dispatch(orderActionCreator.update(order))
          orderEventModule.notify(ORDER_EVENTS.ON_SAVE, { order, isCreation: false } as IOrderEventOnSaveParams)
          resolve({
            order,
            advertiser: advertiser as IAdvertiser
          })
        })
        .catch(error => {
          console.error(error)
          reject(`Unable to update order id="${orderId}"`)
        })
    })
  }
}
